const ErrorScreenContent = ({ brand, message }) => (
  <>
    <h2>We couldn't open this link</h2>
    <p>{message || "There is an issue with your link."}</p>
    <p>
      Please contact us at{" "}
      <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
    </p>
  </>
);

export default ErrorScreenContent;
